// Verbatim copy from Shortcut stories #26530, #26539, #26555, #26561, #26566.
// Do NOT paraphrase — product copy is part of the AC.

// Status colours come from the single source of truth (SC-28528) —
// config/status_colors.json. Do not hardcode status hexes here.
import statusColors from '../../../../../config/status_colors.json';

export const COPY = {
  buttons: {
    openRequest: 'REQUEST ADDITIONAL INFORMATION',
    reply: 'REPLY',
    view: 'VIEW',
    cancel: 'Cancel',
    send: 'Send',
  },
  modal: {
    title: 'Request additional information',
    description: 'Please describe the information/files/images you need from the GP to help you complete this consultation.',
    descriptionForGp: 'Please describe the information/files/images you need from the Specialist.',
    placeholder: '',
    confirmTitle: 'Confirm sending request for additional information',
  },
  gpRequestSection: {
    helpText: 'Need more information from the report? You can request missing details. The consultation will remain closed but the specialist will be notified of your request.',
    constraintEmphasis: 'Please use this only for requesting essential missing details. Only one follow up request is possible per consult.',
  },
  sections: {
    additionalInformationRequested: 'ADDITIONAL INFORMATION REQUESTED',
    additionalInformationYouRequested: 'ADDITIONAL INFORMATION YOU REQUESTED',
    additionalInformationProvided: 'ADDITIONAL INFORMATION PROVIDED',
    additionalInformationLabel: 'Additional Information',
  },
  status: {
    open: 'OPEN',
    openInfoRequested: 'OPEN - INFO REQUESTED',
    openInfoAdded: 'OPEN - INFO ADDED',
    closed: 'CLOSED',
    closedInfoRequested: 'CLOSED - INFO REQUESTED',
    closedInfoAdded: 'CLOSED - INFO ADDED',
  },
  hex: {
    alertRed: statusColors.infoRequested,
    alertRedHover: statusColors.infoRequestedHover,
    closedBlue: statusColors.closedInfoAdded,
    slate500: statusColors.closed,
    inProgress: statusColors.inProgress,
  },
};
